import { render, staticRenderFns } from "./RejectValidationDialog.vue?vue&type=template&id=64339faa"
import script from "./RejectValidationDialog.vue?vue&type=script&lang=js"
export * from "./RejectValidationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports